import React, { useState, useContext } from "react";
import {
  Row,
  Col,
  Card,
  Layout,
  Typography,
  Form,
  Button,
  Divider,
  Modal,
  Space,
  message,
  InputNumber,
  Alert,
} from "antd";
import { ArrowLeftOutlined, WhatsAppOutlined } from "@ant-design/icons";
import { AuthContext } from "../../../contexts/AuthContext";
import http from "../../../services/http";
import { IMAGES } from "../../../constants/images";
const { Title, Text, Link } = Typography;
const { Content } = Layout;

const styles = {
  row: {
    flexGrow: 1,
  },
};

export const VerificacaoLogin = () => {
  const [loading, setLoading] = useState(false);
  const { encerrarSessao, verificar } = useContext(AuthContext);
  const [modal, contextHolder] = Modal.useModal();

  // VERIFICAR LOGIN
  const verificacaoLogin = async (formData) => {
    setLoading(true);
    const api = await http("post", "v1/autenticacao/dois_fatores", formData);
    if (api.statusCode === 200) {
      await verificar(true);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // REENVIAR CÓDIGO
  const reenviarCodigo = async () => {
    setLoading(true);
    const api = await http("get", "v1/autenticacao/reenviar_token?metodo=2", []);
    if (api.statusCode === 200) {
      message.success(api.response.data.message);
      setLoading(false);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // REALIZAR LOGOUT
  const realizarLogout = async () => {
    await http("get", "v1/autenticacao/logout", []);
    message.success("Logout realizado com sucesso!");
    await encerrarSessao();
  };

  return (
    <Row justify="center" align="middle" className="full-width" style={styles?.row}>
      <Col xs={23} sm={18} md={14} lg={12} xl={8} xxl={6}>
        <Card bordered={false}>
          <Row justify="space-around">
            <Col>
              <img width={140} src={IMAGES?.doisFatores} style={{ objectFit: "cover" }} />
            </Col>
          </Row>

          <Title level={3} align="center">
            Código de Verificação
          </Title>
          <Text>O código foi enviado via SMS para seu celular e e-mail.</Text>

          <Divider />
          <Space direction="vertical" size={20}>
            <Form onFinish={verificacaoLogin} layout="vertical" autoComplete="off">
              <Form.Item name="codigo" label="Código" rules={[{ required: true, message: "Digite o código!" }]}>
                <InputNumber
                  size="large"
                  precision={0}
                  className="input-number"
                  min={1}
                  disabled={loading}
                  placeholder="Informe o código"
                />
              </Form.Item>

              <Content align="right">
                <Button
                  type="link"
                  style={{ align: "right" }}
                  loading={loading}
                  onClick={() => {
                    modal.confirm({
                      title: "Deseja reenviar o código?",
                      okText: "Sim",
                      cancelText: "Cancelar",
                      onOk() {
                        reenviarCodigo();
                      },
                    });
                  }}>
                  Reenviar código
                </Button>
              </Content>

              <Button
                size="large"
                loading={loading}
                type="primary"
                htmlType="submit"
                style={{ width: "100%" }}
                className="login-form-button">
                Enviar
              </Button>
            </Form>

            <Alert
              description={
                <Text>
                  Caso tenha algum problema na solicitação do código, entre em contato com o setor de RH ou TI:
                  <br />
                  <Link target="_blank" underline href="https://wa.me/message/WKIFUWDNKN2FG1">
                    <WhatsAppOutlined /> (49) 9 9945-0650
                  </Link>
                </Text>
              }
              type="info"
              showIcon
            />
          </Space>
          <Divider />
          <Space size={20} direction="vertical" style={{ width: "100%" }}>
            <Button
              size="large"
              loading={loading}
              icon={<ArrowLeftOutlined />}
              onClick={realizarLogout}
              className="login-form-button">
              Sair
            </Button>
          </Space>
        </Card>
      </Col>
      {contextHolder}
    </Row>
  );
};
